module.exports = __webpack_public_path__ + "img/u35.f3e89368.png";